import { createContext } from 'react';

export const BuyerContext = createContext({
  setLeft: (comp: any) => {},
  setRight: (comp: any) => {},
  leftPosition: { left: 0, top: 0 },
});
